import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import Header from './components/Header';
import HomeContainer from './components/HomeContainer';
import ProductsPage from './pages/ProductsPage';
import SchedulingPage from './pages/SchedulingPage';
import AdminLogin from './pages/AdminLogin';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminPanel from './pages/AdminPanel';
import ProfilePage from './pages/ProfilePage';
import Footer from './components/Footer';
import StorageDiagnostics from './pages/StorageDiagnostics';
import { CheckoutPage } from './pages/CheckoutPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import OrderSuccessPage from './pages/OrderSuccessPage';
import BookingSuccessPage from './pages/BookingSuccessPage';
import ContentPage from './pages/ContentPage';
import WhatsAppButton from './components/WhatsAppButton';
import SessionExpiredNotification from './components/SessionExpiredNotification';
import CursosPage from './pages/CursosPage';
import EventosPage from './pages/EventosPage';
import NotFoundPage from './pages/NotFoundPage';
import './styles/index.css';
import LocationNewsletter from './components/LocationNewsletter.jsx';
import OpeningAnnouncement from './components/OpeningAnnouncement';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
// --- NUEVA IMPORTACIÓN CLAVE ---
import { useInactivityTimeout } from './hooks/useInactivityTimeout';

// --- NUEVO COMPONENTE AUXILIAR PARA EL HOOK ---
// Este componente se encarga de iniciar y mantener el temporizador de inactividad.
const InactivityWrapper: React.FC = () => {
    // 💡 Aquí se inicia la lógica de timeout de 15 minutos
    useInactivityTimeout();
    return null; // No renderiza nada visible, solo ejecuta la lógica del hook.
};
// ----------------------------------------------


function App() {
  return (
    <ErrorBoundary>
      {/* 💡 CAMBIO CLAVE: Mover el Router para que envuelva a AuthProvider */}
      <Router>
        <AuthProvider>
          {/* Integración del Wrapper de Inactividad (necesita estar dentro del AuthProvider y Router) */}
          <InactivityWrapper />
          
          <CartProvider>
            <Toaster 
              position="bottom-center"
              toastOptions={{
                duration: 3000,
              }}
            />
            <div className="App">
              {/* Notificación de sesión expirada */}
              <SessionExpiredNotification />
              
              {/* No renderizar Header en rutas de administración */}
              <Routes>
                <Route path="/admin/*" element={null} />
                <Route path="*" element={<Header />} />
              </Routes>
              <Routes>
                {/* Home renderizado por contenedor con scroll inteligente */}
                <Route path="/" element={<HomeContainer />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/agendamiento" element={<SchedulingPage />} />
                <Route path="/cursos" element={<CursosPage />} />
                <Route path="/eventos" element={<EventosPage />} />
                <Route path="/producto/:slug" element={<ProductDetailPage />} />
                <Route path="/tienda/:slug" element={<ProductDetailPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/orden-confirmada/:orderId" element={<OrderSuccessPage />} />
                <Route path="/reserva-confirmada/:id" element={<BookingSuccessPage />} />
                <Route path="/orden-fallida" element={<OrderSuccessPage />} />
                <Route path="/orden-pendiente" element={<OrderSuccessPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/terms" element={<ContentPage sectionKey="terminos-y-condiciones" defaultTitle="Términos y Condiciones" />} />
                <Route path="/privacy" element={<ContentPage sectionKey="politica-de-privacidad" defaultTitle="Política de Privacidad" />} />
                {/* Auth routes */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password/:uid/:token" element={<ResetPasswordPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/admin/storage-diagnostics" element={<StorageDiagnostics />} />
                {/* Ruta 404 - debe ir al final */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
              {/* Footer para rutas no administrativas */}
              <Routes>
                <Route path="/admin/*" element={null} />
                <Route path="*" element={<Footer />} />
              </Routes>
              {/* Botón flotante WhatsApp */}
              <Routes>
                <Route path="/admin/*" element={null} />
                <Route path="*" element={<WhatsAppButton />} />
              </Routes>

              {/* Anuncio de Apertura */}
              <Routes>
                <Route path="/admin/*" element={null} />
                <Route path="*" element={<OpeningAnnouncement />} />
              </Routes>
            </div>
          </CartProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;